import React from 'react';
import { BatteryWarning, HelpCircle, Frown } from 'lucide-react';
import { Section } from './Shared';
export function PainSection() {
  return <div className="bg-cream-dark border-y border-beige-muted/50" data-id="element-163">
      <Section className="max-w-4xl" data-id="element-164">
        <div className="grid gap-6 md:grid-cols-3" data-id="element-165">
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-beige-muted/30 flex flex-col items-center text-center" data-id="element-166">
            <div className="bg-sage-light/30 p-4 rounded-full mb-6" data-id="element-167">
              <BatteryWarning className="w-8 h-8 text-sage-dark" data-id="element-168" />
            </div>
            <p className="text-charcoal text-lg font-medium" data-id="element-169">
              Dormís mal hace meses y sentís que ya no podés más
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-sm border border-beige-muted/30 flex flex-col items-center text-center" data-id="element-170">
            <div className="bg-sage-light/30 p-4 rounded-full mb-6" data-id="element-171">
              <HelpCircle className="w-8 h-8 text-sage-dark" data-id="element-172" />
            </div>
            <p className="text-charcoal text-lg font-medium" data-id="element-173">
              Probaste de todo… y nada funciona más de 2 noches seguidas
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-sm border border-beige-muted/30 flex flex-col items-center text-center" data-id="element-174">
            <div className="bg-sage-light/30 p-4 rounded-full mb-6" data-id="element-175">
              <Frown className="w-8 h-8 text-sage-dark" data-id="element-176" />
            </div>
            <p className="text-charcoal text-lg font-medium" data-id="element-177">
              Sentís culpa, frustración y no sabés qué más hacer
            </p>
          </div>
        </div>
      </Section>
    </div>;
}